export const DATA_TESTID_CALCULATE_QUANTITY_BUTTON = 'calculate-quantity-button';
